import { defineComponent, createBlock, openBlock, resolveDynamicComponent, unref, normalizeProps, guardReactiveProps } from "vue";
import { useLocalization } from "./index107.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptCreditNote",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { loadLocalizedComponent } = useLocalization();
    const ReceiptCreditNoteComponent = loadLocalizedComponent("ReceiptCreditNote");
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(ReceiptCreditNoteComponent)), normalizeProps(guardReactiveProps(props)), null, 16);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index8.js.map
